import api from "@/lib/axiosConfig";
import { z, ZodType } from "zod";
import { baseRoute } from "./bibliography";

export const bibliographySchema = z.object({
  id: z.string().optional(),
  bibliographieDescriptionNumeroBibliographie: z
    .string()
    .nonempty("form.error.emptyField"),

  bibliographieDescriptionTitre: z.string(),
});

export const appendNoDuplicateBibliographyNumbersRefine = <
  T extends {
    id?: string;
    bibliographieDescriptionNumeroBibliographie: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateBibliographyNumbers(
        val.bibliographieDescriptionNumeroBibliographie,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.bibliography.duplicateBibliographyNumbers",
      path: ["bibliographieDescriptionNumeroBibliographie"],
    },
  );

export async function validateNoDuplicateBibliographyNumbers(
  bibliographyNumber: string,
  id?: string,
) {
  await api.get<void>(
    `${baseRoute}/bibliography-number/validate/no-duplicates`,
    {
      params: {
        value: bibliographyNumber,
        id,
      },
    },
  );
}
